'use client';

import { useEffect, useState } from 'react';
import { Toaster } from 'sonner';
import { OfflineIndicator } from '@/components/shared/OfflineIndicator';

/**
 * Global client UI only — does not wrap `{children}`.
 *
 * Sonner's `<Toaster />` reads `document` during render (e.g.
 * `useIsDocumentHidden → useState(document.hidden)`), so it must not execute
 * its render on the server. The previous implementation used
 * `next/dynamic(() => import('sonner'), { ssr: false })`, but that emits a
 * lazy webpack chunk which `__webpack_require__.f.j` (the JSONP chunk loader)
 * has been observed to fail in dev mode after HMR / fast navigation, surfacing
 * as a Sentry error on innocuous page loads such as `/sign-in`.
 *
 * Static `import { Toaster }` is safe because Sonner's module init does not
 * touch browser globals (the `document` access lives inside the component's
 * render). Gating the JSX behind a `mounted` flag (`useState(false)` + a
 * `useEffect` that flips it true) skips Toaster's render during SSR and the
 * first client render. The next render — post-effect — actually mounts the
 * Toaster on the client. Same end-user behaviour, no chunk-load surface.
 */
export function AppChrome() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <>
      {mounted ? <Toaster position="top-right" /> : null}
      <OfflineIndicator />
    </>
  );
}
